import $ from "jquery";
import { setAllLikes, debounced } from "./helper";
import deps from "../dependencies";

let current_template_id = null;
let hoverTimeout = null;
let activateTimeout = null;
const DEBOUNCE_TIME = 250;
// Delay before the map reacts to a hover, so quickly skating across cards
// doesn't fire a camera animation for every card it passes.
const ACTIVATE_DEBOUNCE_TIME = 260;

// Function to activate template
function activateTemplate(template_id, itineraryPoints) {
    if (window.innerWidth >= 800 && template_id !== current_template_id) {
        current_template_id = template_id;

        // Show itinerary points on hover
        if (itineraryPoints) {
            dispatchEvent(
                new CustomEvent("map:update-itinerary-points", {
                    detail: { itineraryPoints },
                }),
            );
        } else {
            dispatchEvent(
                new CustomEvent("map:focus-point", {
                    detail: { id: template_id },
                }),
            );
        }
    }
}

// Function to deactivate all templates
function deactivateTemplates() {
    current_template_id = null;
    $("[data-template-preview]").removeClass("s_is-active");
    dispatchEvent(new CustomEvent("map:close-point"));
    dispatchEvent(new CustomEvent("map:clear-itinerary-points"));
}

// Hover on
$(document).on("mouseenter", "[data-template-preview]", function (e) {
    // Prevent execution if dragging
    if ($("body").hasClass("s_is-dragging")) {
        return;
    }

    // Clear any pending deactivation
    if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
    }

    // Clear any pending activation from a card we skated past
    if (activateTimeout) {
        clearTimeout(activateTimeout);
        activateTimeout = null;
    }

    let template_id = $(this).attr("data-template-preview");

    // Remove active class from all items first
    $("[data-template-preview]").removeClass("s_is-active");
    // Add active class to current item
    $(this).addClass("s_is-active");

    if (!template_id) {
        throw new Error("No value for [data-template-preview] found");
    }

    // Parse itinerary points if available
    let itineraryPoints = null;
    try {
        itineraryPoints = JSON.parse(
            $(this).attr("data-template-itinerary-points"),
        );
    } catch (e) {
        // Silently fail since itinerary points are optional
    }

    // Debounce the map update so only the card you settle on moves the camera
    activateTimeout = setTimeout(() => {
        activateTemplate(template_id, itineraryPoints);
    }, ACTIVATE_DEBOUNCE_TIME);
});

// Hover off - use mouseleave on the container or use a timeout approach
$(document).on("mouseleave", "[data-template-preview]", function (e) {
    // Cancel a not-yet-fired activation when leaving the card
    if (activateTimeout) {
        clearTimeout(activateTimeout);
        activateTimeout = null;
    }

    // Set a timeout to deactivate, but only if we're not immediately entering another item
    hoverTimeout = setTimeout(() => {
        const template_id = $(this).attr("data-template-preview");
        deactivateTemplates();
    }, DEBOUNCE_TIME);
});

/**
 * Listen to point-click event
 */
$(window).on("map:point-click", function (e) {
    // Get item
    const item = $(`[data-template-preview="${e.detail.point.id}"]`);

    // Remove active class from all items and add to clicked item
    $("[data-template-preview]").removeClass("s_is-active");
    item.addClass("s_is-active");

    // Only do this on the template filter template
    if ($("body").hasClass("page-template-page-templates-filter-template")) {
        if (window.innerWidth >= 1025) {
            item[0].scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }

    // Handle featured-templates with map-and-slider layout
    const section = item.closest("section");
    if (section.length > 0 && section.hasClass("v_layout_map-and-slider")) {
        const slider = section.find(".sb_featured-templates_items");
        if (slider.length > 0 && deps.flickity) {
            const flickityInstance = deps.flickity.data(slider[0]);
            if (flickityInstance) {
                const slideIndex = item.index();
                flickityInstance.select(slideIndex);
            }
        }
    }
});

/**
 * Listen to point-close event
 */
$(window).on("map:point-close", function () {
    $("[data-template-preview]").removeClass("s_is-active");
    dispatchEvent(new CustomEvent("map:reset"));
});
